import {Component, EventEmitter, Input, Output} from '@angular/core';
export class PromptConfirmComponent {

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'prompt-confirm',
    template: `
        <button class="btn btn-primary">
            <ng-content></ng-content>
        </button>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PromptConfirmComponent_tsickle_Closure_declarations() {
/** @type {?} */
PromptConfirmComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PromptConfirmComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
